// @flow
import React, {Component} from "react";
import Layout from "../../Layout";
import PhotoEBadgeSearchForm from "../../../containers/ebadge/photo/PhotoEBadgeSearchForm";
import PhotoEBadgeQueryResult from "../../../containers/ebadge/photo/PhotoEBadgeQueryResult";
import * as _ from "lodash";
import type {Location} from "../../../types/ReactRouterTypes";
import type {PhotoEBadgeSearchCriteria} from "./PhotoEBadgeSearchForm";
import * as queryString from "query-string";
import auth from "../../../hoc/Authorize";
import type {RoleConfig} from "../../../types/utilityTypes";
import DeleteEBadgePhotoModal from "../../../containers/ebadge/photo/DeleteEBadgePhotoModal";

export const PHOTO_EBADGE_QUERY_PAGE_TITLE = "e-Badge Photo Management";

export type PhotoEBadgeQueryPageDispatchProps = {

    loadSearchResultOnMount: (criteria: PhotoEBadgeSearchCriteria) => any,
    unmount: () => any;
}

type PhotoEBadgeQueryPageProps = {
    location: Location,
    history: {
        push: (path: Location | string) => any
    }
} & PhotoEBadgeQueryPageDispatchProps;

export function parseSearch(search: string): PhotoEBadgeSearchCriteria {

    const criteria: PhotoEBadgeSearchCriteria = queryString.parse(search);
    if (typeof criteria.projectCode === 'string'){
        criteria.projectCode = [criteria.projectCode];
    }
    return criteria;
}

class PhotoEBadgeQueryPage extends Component<PhotoEBadgeQueryPageProps> {

    componentDidMount() {
        if (!_.isEmpty(this.props.location.search)) {

            const criteria: PhotoEBadgeSearchCriteria = parseSearch(this.props.location.search);
            this.props.loadSearchResultOnMount(criteria);
        }
    }

    componentWillUnmount() {
        this.props.unmount();
    }

    render() {

        return (
            <Layout title={PHOTO_EBADGE_QUERY_PAGE_TITLE}>
                <PhotoEBadgeSearchForm />
                <PhotoEBadgeQueryResult/>
                <DeleteEBadgePhotoModal />
            </Layout>
        )
    }
}

export default auth((roleConfig: RoleConfig) => roleConfig.allowPhotoEBadgeManagement)(PhotoEBadgeQueryPage);


// WEBPACK FOOTER //
// ./src/components/ebadge/photo/PhotoEBadgeQueryPage.js